import React from "react";
import { PortfolioAssetField } from "forms/fields";
import sortBy from "lodash/sortBy";
import PropTypes from "prop-types";

const PortfolioAsset = (props) => {
  const {
    assetNames,
    formik: { setFieldValue, values },
    isBroker,
    portfolios,
  } = props;
  const resetAssets = () => setFieldValue("assets", []);
  const { portfolio } = values;
  const assets = portfolio
    ? sortBy(
        assetNames.filter((a) => a.portfolio.id === portfolio.id),
        ["name"]
      )
    : [];

  return (
    <PortfolioAssetField
      assets={assets}
      isBroker={isBroker}
      onSelectPortfolio={resetAssets}
      portfolio={portfolio}
      portfolios={portfolios}
    />
  );
};

PortfolioAsset.propTypes = {
  assetNames: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  portfolios: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  isBroker: PropTypes.bool,
  formik: PropTypes.shape({
    values: PropTypes.shape({
      portfolio: PropTypes.object,
    }),
    setFieldValue: PropTypes.func,
  }),
};

export default PortfolioAsset;
